import React from 'react';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CircleIcon from '@mui/icons-material/Circle';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/functions';

// Memoize the component to avoid unnecessary re-renders
const OrderItem = React.memo((props) => {
    const { orderId, name, image, price, quantity, createdAt, deliveredAt, orderStatus,size } = props;

    // Memoize price and formatted date calculations to avoid recalculating on every render
    const totalAmount = React.useMemo(() => (quantity * price).toLocaleString(), [quantity, price]);
    const formattedCreatedAt = React.useMemo(() => formatDate(createdAt), [createdAt]);
    const formattedDeliveredAt = React.useMemo(() => (deliveredAt ? formatDate(deliveredAt) : null), [deliveredAt]);

    // Render icons and status text
    const renderStatus = () => {
        switch (orderStatus) {
            case "Shipped":
                return (
                    <>
                        <span className="text-primary-orange pb-0.5">
                            <CircleIcon sx={{ fontSize: "14px" }} />
                        </span>
                        Shipped
                    </>
                );
            case "Delivered":
                return (
                    <>
                        <span className="text-primary-green pb-0.5">
                            <CircleIcon sx={{ fontSize: "14px" }} />
                        </span>
                        Delivered on {formattedDeliveredAt}
                    </>
                );
            default:
                return (
                    <>
                        <span className="text-primary-green pb-0.5">
                            <RadioButtonUncheckedIcon sx={{ fontSize: "14px" }} />
                        </span>
                        Ordered on {formattedCreatedAt}
                    </>
                );
        }
    };

    return (
        <Link to={`/order_details/${orderId}`} className="flex p-4 items-start bg-white border rounded gap-2 sm:gap-0 hover:shadow-lg">
            {/* Image container */}
            <div className="w-full sm:w-32 h-20">
                <img draggable="false" className="h-full w-full object-contain" src={image} alt={name} />
            </div>

            {/* Order description container */}
            <div className="flex flex-col sm:flex-row justify-between w-full">
                <div className="flex flex-col gap-1 overflow-hidden">
                    <p className="text-sm">{name.length > 40 ? `${name.substring(0, 40)}...` : name}</p>
                    <p className="text-xs text-gray-500 mt-2">Quantity: {quantity}</p>
                    <p className="text-xs text-gray-500">Size: {size}</p>
                    <p className="text-xs text-gray-500">Total: ₹{totalAmount}</p>
                </div>

                <div className="flex flex-col sm:flex-row mt-1 sm:mt-0 gap-2 sm:gap-20 sm:w-1/2">
                    <p className="text-sm">₹{price.toLocaleString()}</p>

                    <div className="flex flex-col gap-1.5">
                        <p className="text-sm font-medium flex items-center gap-1">
                            {renderStatus()}
                        </p>
                        <p className="text-xs ml-1">
                            {orderStatus === "Delivered" || orderStatus === "Shipped" 
                                ? `Your item has been ${orderStatus}` 
                                : 'Seller has processed your order'}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    );
});

export default OrderItem;
